import React from 'react';
import SecondaryButton from '../../form-components/SecondaryButton/SecondaryButton';
import globalMessages from 'src/services/globalMessages';
import { FormattedMessage, MessageDescriptor } from 'react-intl';
import { isMessageDescriptor } from 'src/components/form-components/helpers';

interface IStepValueProps {
    action: () => void;
    isModifiable: boolean;
    selectedValue?: string | MessageDescriptor;
}

const StepValue: React.FunctionComponent<IStepValueProps> = (props) => {
    const { action, selectedValue, isModifiable } = props;
    return <>
        <span className="booking-step__step-value">
            {isMessageDescriptor(selectedValue)
                ? <FormattedMessage {...selectedValue} />
                : selectedValue
            }
        </span>
        {isModifiable &&
            <SecondaryButton
                className="booking-step__step-btn"
                caption={globalMessages.modify}
                onClick={action}
            />
        }
    </>
};

export default StepValue;
